"use client";

import { usePageType } from "@hooks/usePageType";

interface PageTypeTrackerProps {
  pageType: string;
}

export default function PageTypeTracker({ pageType }: PageTypeTrackerProps) {
  usePageType(pageType);
  return null;
}
